import { render, staticRenderFns } from "./TickerAdminEditMutualFund.vue?vue&type=template&id=6092f930&scoped=true"
import script from "./TickerAdminEditMutualFund.vue?vue&type=script&lang=js"
export * from "./TickerAdminEditMutualFund.vue?vue&type=script&lang=js"
import style0 from "./TickerAdminEditMutualFund.vue?vue&type=style&index=0&id=6092f930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6092f930",
  null
  
)

export default component.exports